import Pager from "./Pager";

export default Pager;
